var App = App || {};

App.OUPSeamlessAccess = (function ($) {
	return {
        init: init,
        updateButton: updateButton
	};

	function init() {
        saveShibbolethID();
        updateButton();
    }


    function updateCheckboxSelector() {

        const $header = $('.js-container-header');
        const $panel = $('.js-login-box-placeholder .js-seamless-checkbox-label');
		
		if ($header.length > 0 && !$header.hasClass('hide')) {
			SCM.SeamlessAccess.updateCheckboxSelector('#ps-checkbox-holder-header');
        } else if ($panel.length > 0 && !$panel.hasClass('hide')) {
			SCM.SeamlessAccess.updateCheckboxSelector('#ps-checkbox-holder-panel');
		}
	}

	function saveShibbolethID() {
		const propertyName = 'SeamlessInstitution';
        const cookie = getCookieValue(propertyName);
		if (cookie) {
            const cookieInstitution = JSON.parse(cookie);
            const localInstitution = SCM.Utilities.LocalStorage.getItem(propertyName);

			if (localInstitution?.entityId !== cookieInstitution.entityId) {
				SCM.Utilities.LocalStorage.setItem(propertyName, cookieInstitution);
				SCM.SeamlessAccess.saveShibbolethID(cookieInstitution.entityId, cookieInstitution.title);
			}
		}
	}

	function getCookieValue(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		if (match) {
			return match[2];
		}
		return '';
    }

    function updateButton() {
        fetchLatestShibbolethData()
            .then(function (persistedInstitutions) {
                if (persistedInstitutions) {
                    return sendSeamlessAccessUpdate(persistedInstitutions);
                }
                throw new Error('No Shibboleth data found');
            })
            .then(updateUIWithSeamlessAccessData)
            .catch(handleSeamlessAccessError);
    }

    function fetchLatestShibbolethData() {
        return SCM.SeamlessAccess.latestShibboleth();
    }

    function sendSeamlessAccessUpdate(persistedInstitutions) {
        return SCM.Ajax.post('/OUP/UpdateSeamlessAccess', persistedInstitutions)
            .sendAsJson()
            .expectJson();
    }

    function updateUIWithSeamlessAccessData(seamlessResultData) {
        updateButtonTextAndLinks(seamlessResultData);
        toggleHeaderButtonVisibility(seamlessResultData);
        setLoginWithLastInstitutionButton(seamlessResultData);
        showCheckboxLabel(seamlessResultData);
        updateCheckboxSelector();
    }

    function updateButtonTextAndLinks(resultData) {
        const $seamlessButtonHeader = $('.seamless-button-header');
        const $lastInstitutionButton = $('.js-seamless-access-last-intitution');
        const $changeInstitutionButton = $('.login-box-button-panel');
        const $lastInstitutionButtonText = $('.seamless-access-text').not('.js-change-institution-text');
        const $changeInstitutionButtonText = $('.js-change-institution-text');

        if (resultData.SeamlessButtonActionType && resultData.SeamlessButtonText) {
            // Always update header button
            $seamlessButtonHeader.attr('data-action-type', resultData.SeamlessButtonActionType)
                .attr('data-entity-id', resultData.SeamlessButtonEntityId);

            if (resultData.ShowLoginWithLastInstitutionButton) {
                // User data is stored: Show both buttons with different actions
                // First button: Direct login to known institution
                $lastInstitutionButton.attr('data-action-type', resultData.SeamlessButtonActionType)
                    .attr('data-entity-id', resultData.SeamlessButtonEntityId);
                $lastInstitutionButtonText.text(resultData.SeamlessButtonText);

                // Second button: Change institution / discovery
                if (resultData.ChangeInstitutionLinkActionType) {
                    $changeInstitutionButton.attr('data-action-type', resultData.ChangeInstitutionLinkActionType);
                }
            } else {
                // No user data is stored: Second button becomes the main discovery button
                $changeInstitutionButton.attr('data-action-type', resultData.SeamlessButtonActionType)
                    .attr('data-entity-id', resultData.SeamlessButtonEntityId);
                $changeInstitutionButtonText.text(resultData.SeamlessButtonText);
            }
        }
    }

    function showCheckboxLabel(resultData) {

        const $labelHeader = $('.seamless-checkbox-container.js-container-header');
        const $labelElement = $('.js-login-box-placeholder .js-seamless-checkbox-label');

        if (resultData.ShowAccessCheckboxInPanel) {        
            $labelHeader.addClass('hide');
            $labelElement.removeClass('hide');
        } else {
            $labelHeader.removeClass('hide');
            $labelElement.addClass('hide');
        }
    }

    function toggleHeaderButtonVisibility(resultData) {
        const $seamlessButtonHeader = $('.seamless-button-header');
        resultData.ShowHeaderSeamlessButton ? $seamlessButtonHeader.removeClass('hide') : $seamlessButtonHeader.addClass('hide');
    }

    function setLoginWithLastInstitutionButton(resultData) {
        const $loginWithLastInstitutionButton = $('.js-seamless-access-last-intitution');
        if (resultData.ShowLoginWithLastInstitutionButton) {
            $loginWithLastInstitutionButton.removeClass('hide');
        } else {
            $loginWithLastInstitutionButton.addClass('hide');
        }          
    }

    function handleSeamlessAccessError(reason) {
        console.error("Error updating seamless access button:", reason);
    }
})(jQuery);